<script lang="ts" setup>
import NavbarItem from './NavbarItem.vue';
const props = defineProps(["data", "parentPath", "title"])
</script>

<template lang="pug">
ul
  li.menu-title(v-if="title") {{ title }}
  NavbarItem(v-for="item in props.data" :data="item" :parentPath="parentPath")
</template>

<style lang="sass" scoped>

</style>